'use strict';

var Backbone = require('backbone');
var Radio = require('backbone.radio');
var _ = require('underscore');
var $ = require('jquery');

export default Backbone.View.extend({

  tagName: 'ol',
  className: 'step-indicator',

  initialize: function () {
    Radio.channel('steps').on('change:current', this.render, this);
    Radio.channel('steps').on('removed', this.render, this);
  },

  render: function () {
    this.$el.empty();

    var steps = Radio.channel('steps').request('list');
    var active = Radio.channel('steps').request('currentIndex');

    var $step;
    for (var i = 0; i < steps.length; i++) {
      $step = $('<li>' + steps[i].short_title + '</li>').appendTo(this.$el);
      if (i == active) {
        $step.addClass('active');
      }

      $step.css('width', this.getStepWidth(i) + '%');
      $step.css('margin-left', this.getStepLeftMargin(i) + '%');
    }

    return this;
  },

  getStepWidth: function (number) {
    if (number === 0) {
      return 0;
    }

    var length = Radio.channel('steps').request('count') - 1;
    if (number === length) {
      return 100 * (1 / length);
    }

    return 100 * (2 / length);
  },

  getStepLeftMargin: function (number) {
    if (number === 0) {
      return 0;
    }

    var length = Radio.channel('steps').request('count') - 1;

    return 100 * ((number - 1) / length);
  },

});
